import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

const PHONE_NUMBER = "0522340659";
const EMAIL = "info@domoelec.ma";
const WHATSAPP_URL = `https://wa.me/212668992831?text=${encodeURIComponent(
  "Bonjour, je contacte DOMOELEC depuis le site web."
)}`;

const FloatingContactMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = useCallback(() => setIsOpen(false), []);
  const toggleMenu = useCallback(() => setIsOpen((v) => !v), []);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeMenu();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, closeMenu]);

  const optionTabIndex = isOpen ? 0 : -1;

  return (
    <div className={`fcm${isOpen ? " fcm--open" : ""}`}>
      <div className="fcm-menu" id="fcm-menu" aria-hidden={!isOpen}>
        <a
          className="fcm-btn fcm-btn--phone"
          href={`tel:${PHONE_NUMBER}`}
          title="Appel direct"
          aria-label={`Appeler DOMOELEC au ${PHONE_NUMBER}`}
          tabIndex={optionTabIndex}
        >
          <i className="fas fa-phone-alt" aria-hidden="true"></i>
          <span className="fcm-label" aria-hidden="true">Appel direct</span>
        </a>
        <a
          className="fcm-btn fcm-btn--whatsapp"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          title="WhatsApp"
          aria-label="Discuter avec DOMOELEC sur WhatsApp"
          tabIndex={optionTabIndex}
        >
          <i className="fab fa-whatsapp" aria-hidden="true"></i>
          <span className="fcm-label" aria-hidden="true">WhatsApp</span>
        </a>
        <a
          className="fcm-btn fcm-btn--email"
          href={`mailto:${EMAIL}`}
          title="Envoyer un e-mail"
          aria-label={`Envoyer un e-mail à ${EMAIL}`}
          tabIndex={optionTabIndex}
        >
          <i className="fas fa-envelope" aria-hidden="true"></i>
          <span className="fcm-label" aria-hidden="true">Envoyer un e-mail</span>
        </a>
        <Link
          className="fcm-btn fcm-btn--contact"
          to="/contact"
          title="Formulaire de contact"
          aria-label="Accéder à la page de contact DOMOELEC"
          tabIndex={optionTabIndex}
          onClick={closeMenu}
        >
          <i className="fas fa-address-book" aria-hidden="true"></i>
          <span className="fcm-label" aria-hidden="true">Formulaire de contact</span>
        </Link>
      </div>
      <button
        type="button"
        className="fcm-toggle"
        onClick={toggleMenu}
        aria-expanded={isOpen}
        aria-controls="fcm-menu"
        aria-label={isOpen ? "Fermer le menu de contact" : "Ouvrir le menu de contact"}
        title={isOpen ? "Fermer" : "Nous contacter"}
      >
        <i className="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
  );
};

export default FloatingContactMenu;
